import { Drawer as MuiDrawer, SxProps } from '@mui/material';
import { modalContent, modalHeader } from './modal.css';
import { useBreakpoints } from '@design-system/breakpointsStore';
import {
  closeWrapperSideModal,
  drawerWrapper,
  noSpacing,
  sideModal,
  sideModalContent,
  sideModalHeaderWrapper,
} from './sideModal.css';
import { ModalCta, ModalCtaProps } from './modalCta';
import {
  ModalDescription,
  ModalTitle,
  ModalTypographyProps,
} from './modalTypography';
import { ModalCloseButton } from './modalCloseIcon';
import { ReactNode } from 'react';

export type DrawerProps = React.PropsWithChildren<{
  isOpen: boolean;
  onClose: () => void;
  drawerSx?: SxProps;
}>;

export const Drawer = (p: DrawerProps) => (
  <MuiDrawer
    anchor="right"
    className={drawerWrapper}
    open={p.isOpen}
    onClose={p.onClose}
    sx={p?.drawerSx}
  >
    {p.children}
  </MuiDrawer>
);

export type SideModalProps = DrawerProps &
  ModalCtaProps &
  ModalTypographyProps & {
    hideCloseButton?: boolean;
    headerComponents?: ReactNode;
    titleClassName?: string;
    noSpacing?: boolean;
  };

export const SideModal = (p: SideModalProps) => {
  const desktop = useBreakpoints((s) => s.desktop);

  const ctaElement = (
    <ModalCta primaryCta={p.primaryCta} secondaryCta={p.secondaryCta} />
  );

  return (
    <Drawer {...p}>
      <div className={p.noSpacing ? noSpacing : sideModal}>
        <div className={modalHeader}>
          <div className={sideModalHeaderWrapper}>
            {p.title ? (
              <div className="flex gap-6 items-center">
                <ModalTitle
                  title={p.title}
                  largeTitle
                  className={p?.titleClassName}
                />
                {p?.headerComponents ? p.headerComponents : null}
              </div>
            ) : null}
            {desktop && ctaElement}
          </div>

          <ModalDescription description={p.description} />

          {p.hideCloseButton ? null : (
            <ModalCloseButton
              className={closeWrapperSideModal}
              onClick={p.onClose}
            />
          )}
        </div>

        <div className={modalContent}>
          <div className={sideModalContent}>{p.children}</div>
          {!desktop && ctaElement}
        </div>
      </div>
    </Drawer>
  );
};
